import React, { useState } from "react";
import { Modal, Button, Form } from "semantic-ui-react";
import notify from "devextreme/ui/notify";
import { connect } from "react-redux";
import { UserSign } from "../login/UserSign";
import { recalculateAllOrders } from "../orders/service";
import { Trans, t } from "@lingui/macro";
import { i18n } from "../i18n/components/ConnectProvider";

const RecalculateButton = ({ username }) => {
  const initialData = {
    open: false,
    username: username,
    password: "",
    reason: ""
  };

  const [data, setData] = useState(initialData);
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "25px 0 0 0"
        }}
      >
        <div>
          <Button onClick={() => setData({ ...data, open: true })} color="red">
            <Trans>Recalcular todas las ordenes</Trans>
          </Button>
        </div>
      </div>
      <Modal
        size={"tiny"}
        dimmer={"inverted"}
        open={data.open}
        onClose={() => setData({ ...initialData, open: false })}
      >
        <Modal.Header as="h2">
          <Trans>Recalcular todas las ordenes</Trans>
        </Modal.Header>
        <Modal.Content>
          <Form>
            <UserSign
              data={data}
              setData={setData}
              user={username}
              reason={false}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content={i18n()._(t`Cancelar`)}
            onClick={() => setData({ ...initialData, open: false })}
          />
          <Button
            content={i18n()._(t`Aplicar`)}
            onClick={() => {
              notify("Esto podría demorar un momento...", "info");
              recalculateAllOrders(data.username, data.password)
                .then(orders =>
                  notify(`Success: ${orders} orders recalculated`, "success")
                )
                .catch(err => {
                  notify(err, "error", 5000);
                  console.error(err);
                });
              setData({ ...data, open: false });
            }}
          />
        </Modal.Actions>
      </Modal>
    </>
  );
}

const mapStateToProps = state => {
  return {
      auth: state.authentication
  };
};

export default connect(mapStateToProps)(RecalculateButton);